
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("bedbuilder", ["activeOptions"]),
  },
};
